import { REQUEST_FETCH_CAMPAIGNS, FETCH_CAMPAIGNS_SUCCESS, FETCH_CAMPAIGNS_ERROR } from './actionTypes';

export const requestFetchCampaigns = () => ({ type: REQUEST_FETCH_CAMPAIGNS });
export const fetchCampaignsSuccess = campaigns => ({ type: FETCH_CAMPAIGNS_SUCCESS, payload: campaigns });
export const fetchCampaignsError = error => ({ type: FETCH_CAMPAIGNS_ERROR, payload: error });
